import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    loading: false,
  },
  getters: {
    list: (state) => state.list,
    details: (state) => state.details,
    loading: (state) => state.loading,
  },
  actions: {
    create({ dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("ProductManagement/api/ActualProducts", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    update({ dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("ProductManagement/api/ActualProducts", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/ActualProductsQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetch({ commit }) {
      return ajax.get("ProductManagement/api/ActualProductsQuery").then((r) => {
        commit("setList", r.data.data);
      });
    },

    remove({ dispatch }, id) {
      return ajax
        .delete(
          "ProductManagement/api/ActualProducts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },

    fetchSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ActualProductsQuery/" + name + "/tiny-info")
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
};
